export default __webpack_public_path__ + "static/media/man-6253257_1920.e1d2e155.jpg";